import { setupStore } from "@kubera/common";
import localForage from "localforage";
// import { setGlobalDevModeChecks } from "reselect";

export const configureStore = () => {
  // @TODO: Enable below line when necessary
  // setGlobalDevModeChecks({ inputStabilityCheck: "never" }); // Disable warnings in local so that app doesn't break due to reselect warnings
  setupStore(localForage);
};
